import { View, Text } from '@react-pdf/renderer';
import { footerStyle } from './style';
import { OrganizationWithPolicies } from '../../../commonTypes/organization.types';

type FooterProps = {
    organization?: OrganizationWithPolicies;
};

export const InvoiceFooter = ({ organization }: FooterProps) => {
    return (
        <View style={footerStyle.container}>
            <View style={footerStyle.leftSection}>
                <Text style={footerStyle.organizationName}>{organization?.name}</Text>
            </View>
            <View style={footerStyle.rightSection}>
                <Text style={footerStyle.infoText}>{organization?.phone}</Text>
                <Text style={footerStyle.infoText}>{organization?.contactEmail}</Text>
            </View>
        </View>
    );
};
